import { Button, Modal, Select, Spin } from "antd"
import React, { Component, Fragment } from "react"
import Chart from "react-google-charts"
import { findWhereMultiple } from "../../../../utils/db_functions"
import { surveyQuestionsAndAnswers } from "../suport-files/survey-questions"

export default class QualificationSurveyReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            year: null,
            reportModal: false,
            loading: false,
            surveyAmount: 0,
            chartData: surveyQuestionsAndAnswers.map(survey => {
                return {
                    question: survey.question.key,
                    title: survey.question.label,
                    data: []
                }
            })
        }
    }

    getSurveyByYear = async (year) => {
        this.setState({ loading: true })

        const surveys = await findWhereMultiple(
            'QualificationSurvey',
            [
                { 'field': 'createdAt', 'value': new Date(year, 0, 1), 'op': 'greatherThan', 'logicOp': '$and', 'isDateType': true },
                { 'field': 'createdAt', 'value': new Date(year, 11, 31), 'op': 'lessThan', 'logicOp': '$and', 'isDateType': true },
            ],
            null, null, 500
        )

        // Pegandos as respostas
        const questions = this.state.chartData.map(el => el.question)
        const allAnswers = questions.map(question => {
            const answers = surveys.map(survey => survey.get('form')[`${question}`])
            return {
                question,
                answers: [...new Set(answers)].filter(el => el)
            }
        })

        // Contando as respostas
        const chartData = this.state.chartData.map(chart => {

            const questionAndAnswers = allAnswers.find(el => el.question === chart.question)
            if (questionAndAnswers) {
                let data = []
                questionAndAnswers.answers.forEach(answer => {
                    let count = 0
                    surveys.forEach(survey => {
                        if (survey.get('form')[`${chart.question}`] === answer) count++
                    })
                    data.push([`${answer}`, count])
                })
                chart.data = data
                return chart
            } else return chart
        })

        this.setState({ chartData, loading: false, surveyAmount: (surveys.length || 0) })
    }

    render() {
        return (
            <Fragment>
                <Button
                    onClick={() => this.setState({ reportModal: true })}
                    style={{ marginRight: '10px' }}
                >Gráficos</Button>

                <Modal
                    width={950}
                    visible={this.state.reportModal}
                    title='Relatório de pesquisa de qualificação'
                    onCancel={() => this.setState({ reportModal: false })}
                    footer={[
                        <Button type="primary" onClick={() => this.setState({ reportModal: false })}>Ok</Button>
                    ]}
                >
                    <Spin spinning={this.state.loading} tip='Carregando gráficos...'>
                        <div>
                            <Select
                                style={{ width: '300px', marginTop: '10px', marginBottom: '30px' }}
                                value={this.state.year}
                                onChange={year => {
                                    this.setState({ year })
                                    this.getSurveyByYear(year)
                                }}
                            >
                                {
                                    Array(33).fill(2018).map((year, yearIndex) => {
                                        return <Select.Option key={year + yearIndex} value={year + yearIndex}>{year + yearIndex}</Select.Option>
                                    })
                                }
                            </Select>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            Pesquisas respondidas no período: <strong>{this.state.surveyAmount}</strong>
                        </div>

                        {
                            this.state.chartData.map((chartData, index) => {
                                return (
                                    <Chart
                                        key={`customerChartKey${index}`}
                                        chartType="PieChart"
                                        options={{
                                            width: 950,
                                            height: 300,
                                            title: chartData.title,
                                            is3D: true,
                                        }}
                                        loader={<div>Carregando gráfico</div>}
                                        data={[
                                            ['Pergunta', 'Resposta'],
                                            ...chartData.data
                                        ]}
                                    />
                                )
                            })
                        }

                    </Spin>

                </Modal>
            </Fragment>
        )
    }
}